import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./Styles/BlogDetail.css";

const BlogDetail = () => {
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const { id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        fetchBlog();
        checkAdminStatus();
    }, [id]);

    const checkAdminStatus = async () => {
        try {
            const cookies = document.cookie.split("; ");
            const userEmailCookie = cookies.find(row => row.startsWith("userEmail="));
            if (userEmailCookie) {
                const email = userEmailCookie.split("=")[1];
                const response = await fetch(`https://dalhousiecombatroboticsteam.onrender.com/check-admin?email=${email}`);
                const data = await response.json();
                setIsAdmin(data.isAdmin);
            }
        } catch (error) {
            console.error("Error checking admin status:", error);
        }
    };

    const fetchBlog = async () => {
        try {
            const response = await fetch(`https://dalhousiecombatroboticsteam.onrender.com/blog/${id}`);
            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || "Failed to fetch blog");
            }

            setBlog(data);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching blog:", error);
            setError(error.message || "Failed to load blog. Please try again later.");
            setLoading(false);
        }
    };

    const handleDelete = async () => {
        if (!window.confirm("Are you sure you want to delete this blog post?")) {
            return;
        }

        try {
            const response = await fetch(`https://dalhousiecombatroboticsteam.onrender.com/blog/${id}`, {
                method: 'DELETE',
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || "Failed to delete blog");
            }

            alert("Blog post deleted successfully!");
            navigate("/blogs");
        } catch (error) {
            console.error("Error deleting blog:", error);
            alert(error.message || "Failed to delete blog post");
        }
    };

    if (loading) {
        return (
            <div className="blog-detail-container">
                <div className="loading-spinner">Loading...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="blog-detail-container">
                <div className="error-message">
                    <h3>Error</h3>
                    <p>{error}</p>
                    <button onClick={fetchBlog} className="retry-button">
                        Retry
                    </button>
                </div>
            </div>
        );
    }

    if (!blog) {
        return (
            <div className="blog-detail-container">
                <div className="error-message">
                    <h3>Blog Not Found</h3>
                    <p>The blog post you're looking for doesn't exist.</p>
                    <button onClick={() => navigate("/blogs")} className="retry-button">
                        Back to Blogs
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="blog-detail-container">
            <div className="blog-detail-content">
                <div className="blog-header">
                    <h1>{blog.title}</h1>
                    <div className="blog-meta">
                        <span>By {blog.author}</span>
                        <span>•</span>
                        <span>{new Date(blog.createdAt).toLocaleDateString()}</span>
                    </div>
                    {isAdmin && (
                        <div className="admin-actions">
                            <button onClick={handleDelete} className="delete-button">
                                Delete Blog
                            </button>
                        </div>
                    )}
                </div>

                {blog.images && blog.images.length > 0 && (
                    <div className="blog-images">
                        {blog.images.map((image, index) => (
                            <div key={index} className="blog-image-container">
                                <img src={image} alt={`Blog image ${index + 1}`} />
                            </div>
                        ))}
                    </div>
                )}

                <div className="blog-description">
                    {blog.description.split('\n').map((paragraph, index) => (
                        <p key={index}>{paragraph}</p>
                    ))}
                </div>

                <button onClick={() => navigate("/blogs")} className="back-button">
                    Back to Blogs
                </button>
            </div>
        </div>
    );
};

export default BlogDetail; 